// components/MarketCard.jsx - 市场卡片组件
import React from 'react';
import './MarketCard.css';
import { formatCurrencyCompact as formatCurrency, formatCompact } from '../utils/numberFormat';

const MarketCard = ({ market, onClick, onBetClick }) => {
  const [busy, setBusy] = React.useState(false);
  // 格式化日期
  const formatDate = (date) => {
    const options = { month: 'short', day: 'numeric' };
    return new Date(date).toLocaleDateString('en-US', options);
  };

  // 格式化金额与数字统一


  // 处理下注按钮点击
  const handleBetClick = (e, side) => {
    e.stopPropagation();
    if (busy) return;
    setBusy(true);
    try { onBetClick(market, side); } finally {
      setTimeout(() => setBusy(false), 800);
    }
  };

  return (
    <div className="market-card" onClick={onClick}>
      <div className="card-header">
        <div className="market-category">
          <span className="market-id-badge">#{market.id}</span>
          <span className={`category-tag ${market.category}`}>{market.category}</span>
          {market.resolution !== 'pending' && (
            <span className={`resolution-tag ${market.resolution}`}>
              {market.resolution === 'yes' ? 'Resolved: YES' : 'Resolved: NO'}
            </span>
          )}
        </div>
        <div className="market-end">
          <span>Ends: {formatDate(market.endDate)}</span>
        </div>
      </div>

      <div className="card-body">
        <h3 className="market-title">{market.title}</h3>

        <div className="market-stats">
          <div className="stat">
            <div className="stat-label">Volume</div>
            <div className="stat-value">{formatCurrency(market.volume)}</div>
          </div>
          <div className="stat">
            <div className="stat-label">Participants</div>
            <div className="stat-value">{Math.trunc(Number(market.participants || 0)).toLocaleString()}</div>
          </div>
          <div className="stat">
            <div className="stat-label">Liquidity</div>
            <div className="stat-value">{formatCurrency(market.liquidity?.virtual)}</div>
          </div>
        </div>

        <div className="price-display">
          <div className="price-yes">
            <div className="price-label">YES</div>
            <div className="price-value">${market.yesPrice}</div>
            <div className="price-probability">
              Probability: {((Number(market.yesPrice) || 0) * 100).toFixed(1)}%
            </div>
          </div>
          <div className="price-no">
            <div className="price-label">NO</div>
            <div className="price-value">${market.noPrice}</div>
            <div className="price-probability">
              Probability: {((Number(market.noPrice) || 0) * 100).toFixed(1)}%
            </div>
          </div>
        </div>


      </div>

      <div className="card-footer">
        <button
          className="bet-btn yes-btn"
          onClick={(e) => handleBetClick(e, 'yes')}
          disabled={busy}
        >
          Buy YES
        </button>
        <button
          className="bet-btn no-btn"
          onClick={(e) => handleBetClick(e, 'no')}
          disabled={busy}
        >
          Buy NO
        </button>
      </div>
    </div>
  );
};

export default MarketCard;
